import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';
import ThemeSwitcher from '../ThemeSwitcher';

function Login({ onLogin, onRegister }) {
    const { t } = useTranslation();
    const [mode, setMode] = useState('login');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const submit = async () => {
        if (loading) return;
        setLoading(true);
        try {
            if (mode === 'login') {
                await onLogin({ email, password });
            } else {
                await onRegister({ name, email, password });
            }
        } finally {
            setLoading(false);
        }
    };

    const onKeyDown = (e) => {
        if (e.key === 'Enter') submit();
    };

    const isRegister = mode === 'register';

    return (
        <div className="min-h-screen flex items-center justify-center p-3 sm:p-6">
            <div className="neon-panel scanlines overflow-hidden w-full max-w-md p-5 sm:p-10 animate-pulse-neon">
                <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-cyber-cyan to-transparent" />
                <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-cyber-purple to-transparent" />

                <div className="text-center mb-6">
                    <div className="neon-label mb-2">{t('login.systemBoot')}</div>
                    <h1 className="text-3xl sm:text-4xl font-black text-white glow-cyan">BG<span className="glow-purple text-cyber-purple ml-1">GAMES</span></h1>
                    <div className="text-xs text-cyber-dim mt-2 tracking-widest">{t('login.tagline')}</div>
                </div>

                <div className="mb-6">
                    <div className="neon-label text-center mb-2">{t('login.chooseLanguage')}</div>
                    <div className="flex justify-center items-center gap-3">
                        <LanguageSwitcher variant="dropdown-up-md" />
                        <ThemeSwitcher placement="top" size="md" />
                    </div>
                </div>

                <div className="flex gap-2 mb-6">
                    <button
                        onClick={() => setMode('login')}
                        className={`flex-1 py-2 text-xs tracking-widest ${mode === 'login' ? 'neon-btn' : 'text-cyber-dim'}`}
                    >
                        {t('login.logIn')}
                    </button>
                    <button
                        onClick={() => setMode('register')}
                        className={`flex-1 py-2 text-xs tracking-widest ${mode === 'register' ? 'neon-btn' : 'text-cyber-dim'}`}
                    >
                        {t('login.register')}
                    </button>
                </div>

                <div className="space-y-4">
                    {isRegister && (
                        <div>
                            <label className="neon-label block mb-2">{t('login.handle')}</label>
                            <input
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                onKeyDown={onKeyDown}
                                placeholder={t('login.handlePlaceholder')}
                                className="neon-input w-full"
                                autoFocus
                            />
                        </div>
                    )}
                    <div>
                        <label className="neon-label block mb-2">{t('login.email')}</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={onKeyDown}
                            placeholder={t('login.emailPlaceholder')}
                            className="neon-input w-full"
                            autoFocus={!isRegister}
                        />
                    </div>
                    <div>
                        <label className="neon-label block mb-2">{t('login.password')}</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={onKeyDown}
                            placeholder="••••••••"
                            className="neon-input w-full"
                        />
                    </div>
                    <button onClick={submit} disabled={loading} className="neon-btn w-full py-3 text-base">
                        {loading ? t('login.connecting') : isRegister ? t('login.createAccount') : t('login.jackIn')}
                    </button>
                </div>

                <div className="mt-8 flex items-center justify-between text-[10px] text-cyber-dim tracking-widest">
                    <span className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full bg-cyber-cyan animate-pulse" />
                        {t('login.nodeOnline')}
                    </span>
                    <span>BlackGold</span>
                </div>
            </div>
        </div>
    );
}

export default Login;
